// Compose
import React from 'react'
import { compose, withHandlers } from 'recompose'
import PropTypes from 'prop-types'
import { StyledMenuItem } from '../../../theme/Global'

export const MenuItemFactory = (item) => compose(
  withHandlers({
    onClick: (props) => () => {
      props.activate(item)
    }
  })
)(StyledMenuItem)

const MenuItemRenderer = ({ activateItem, index, item }) => {
  const Item = MenuItemFactory(item)
  return (
    <Item key={index} activate={activateItem}>
      {item.text}
    </Item>
  )
}

MenuItemRenderer.propTypes = {
  activateItem: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default MenuItemRenderer
